var _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRpmMonitor0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_0",
    "data-name": 0,
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9811",
    "data-name": "Group 9811"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4307",
    "data-name": "Rectangle 4307",
    width: 13,
    height: 2.6,
    transform: "translate(0 17.4)",
    fill: "#929497"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4308",
    "data-name": "Rectangle 4308",
    width: 13,
    height: 20,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRpmMonitor0);
export default __webpack_public_path__ + "static/media/rpm_monitor_0.1c8de0dba7263ded9402f4d12c78d350.svg";
export { ForwardRef as ReactComponent };